function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (deferredElement.tagName == "VIDEO") {
        deferredElement.addEventListener("click", () => {
          if (deferredElement.paused) {
            deferredElement.play();
          } else {
            deferredElement.pause();
          }
        });
      }

      if (focus) deferredElement.focus();
    } else {
      const deferredElement = this.querySelector("video");
      if (deferredElement.tagName == "VIDEO") {
        if (deferredElement.paused) {
          deferredElement.play();
        } else {
          deferredElement.pause();
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class ResponsiveDeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      if (IsThisMobileSize == "true") {
        content.appendChild(
          this.querySelector("template").content.lastElementChild.cloneNode(
            true
          )
        );
      } else {
        content.appendChild(
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          )
        );
      }

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (deferredElement.tagName == "VIDEO") {
        deferredElement.addEventListener("click", () => {
          if (!deferredElement.paused) {
            deferredElement.play();
          } else {
            deferredElement.pause();
          }
        });
      }

      if (focus) deferredElement.focus();
    } else {
      const deferredElement = this.querySelector("video");
      if (deferredElement.tagName == "VIDEO") {
        if (deferredElement.paused) {
          deferredElement.play();
        } else {
          deferredElement.pause();
        }
      }
    }
  }
}

customElements.define("responsive-deferred-media", ResponsiveDeferredMedia);
